var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Want To Sell"}}),_c('ContentRow',[_c('ContentContainer',[_c('Form',{attrs:{"type":"Variations.BarrierReefBusinessBrokers.WantToSellForm"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }